import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'
import { GroupVisibility } from 'app/types/GroupVisibility'

const query = gql`
  query fetchModeratedUserGroups($limit: Int!, $page: Int!) {
    userModeratedGroups(limit: $limit, page: $page) {
      totalDocs
      docs {
        id
        isOwner
        isModerator
        group {
          id
          name
          totalMembers
          visibility
          profileImage {
            id
            sizes {
              small {
                url
              }
              medium {
                url
              }
            }
          }
          university {
            slug
          }
          universityCourse {
            slug
          }
          allowedUserTypes
        }
      }
    }
  }
`

export interface ModeratedUserGroupsQueryInput {
  page: number
  limit: number
}

export interface ModeratedUserGroupsQueryOutput {
  userModeratedGroups: {
    totalDocs: number
    docs: {
      isOwner: boolean
      isModerator: boolean
      group: {
        id: string
        name: string
        totalMembers: number
        visibility: GroupVisibility
        profileImage: {
          id: string
          sizes: {
            small: {
              url: string
            }
            medium: {
              url: string
            }
          }
        }
        university?: {
          slug: string
        }
        universityCourse?: {
          slug: string
        }
        allowedUserTypes: string[]
      }
    }[]
  }
}

const defaultVariables: ModeratedUserGroupsQueryInput = {
  page: 1,
  limit: 500,
}

export const useModeratedUserGroupsQuery = (
  options?: QueryHookOptions<ModeratedUserGroupsQueryOutput, ModeratedUserGroupsQueryInput>
) =>
  usePersistedCacheQuery<ModeratedUserGroupsQueryOutput, ModeratedUserGroupsQueryInput>(query, {
    variables: defaultVariables,
    ...options,
  })

export const userModeratedGroupsQuery = { query, defaultVariables }
